module.exports = "/spread_success-de079d28c61f30e06abd55c9fc6d0ca2.svg";